import ForumScreen from './containers/forumScreen'

export {default as ForumScreenLayout} from './components/forumScreenLayout'

export default ForumScreen
